import React, { useContext, useRef, useState } from 'react';
import {
    Marker,
    Tooltip,
    Popup,
    useMap
} from "react-leaflet";
import L from 'leaflet';
import { spotList } from './config';
import { useCookies } from "react-cookie";
// eslint-disable-next-line
import { Chart } from 'chart.js/auto';
import { Line } from "react-chartjs-2";
import { tmpAPI } from '../../../utils/api';
import { Context } from '../../../store/reducer';

const Component = ({index, latitude, longitude, category, draggable=false}) => {
    const { state, dispatch } = useContext(Context);
    // eslint-disable-next-line
    const [cookies,setCookie,removeCookie] = useCookies(["spots"]);
    const spots = cookies.spots || []
    const iconUrl = new L.Icon({
        iconUrl: spotList[spotList.findIndex(spot => spot.name == category)].src,
        iconRetinaUrl: spotList[spotList.findIndex(spot => spot.name == category)].src,
        iconSize: [35, 35],
        iconAnchor: [17, 23],
        popupAnchor: [0, -50]
    });
    const [name, setName] =  useState(index != -1 && spots[index] ? spots[index].name || category : null)
    const [memo, setMemo] =  useState(index != -1 && spots[index] ? spots[index].memo : null)
    const popupRef = useRef(null)
    const map = useMap()
    const bounds = map.getBounds()
    const minlat = bounds._southWest.lat
    const maxlat = bounds._northEast.lat
    const minlng = bounds._southWest.lng
    const maxlng = bounds._northEast.lng

    if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){
        return (
        
                <Marker 
                position={[latitude,longitude]} 
                icon={iconUrl} 
                draggable={draggable}
                eventHandlers={{
                    dragend(e) {
                        const position = e.target.getLatLng();
                        spots[index].latitude = position.lat;
                        spots[index].longitude = position.lng;
                        setCookie("spots", spots, {maxAge:60*60*24*7});
                    },
                    async click(e) {
                        if(process.env.REACT_APP_KASHIKA == 2) {
                            try{
                                const res = await tmpAPI.get("/demo");
                            } catch {
                                console.log("ポップアップ情報の取得に失敗しました。");
                            }
                            dispatch({
                                type: 'SET_CURRENT_POPUP',
                                payload: state.popups[state.timeIdx]
                            })
                        }
                    }
                }}
            >
                { process.env.REACT_APP_KASHIKA == 1 && index != -1 &&
                    <Popup ref={popupRef} autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
                        <dl className="dl-list is-modal-spot is-first">
                            <dt >スポット名</dt>
                            <dd>
                                <input type="text" className="f-w-lg"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                placeholder="例：空き家" />
                            </dd>
                        </dl>
                        <dl className="dl-list is-modal-spot">
                            <dt>メモ</dt>
                            <dd>
                                <textarea rows='2' className='f-w-lg' 
                                value={memo}
                                onChange={e => setMemo(e.target.value)}
                                placeholder='例：倒壊の恐れ'></textarea>
                            </dd>
                        </dl>
                        { state.registerMode &&
                            <ul className="submit-side">
                                <li>
                                    <button className='c-btn c-btn-solid c-btn-xs' type="button" 
                                        onClick={() => {
                                            spots[index].name = name
                                            spots[index].memo = memo
                                            setCookie("spots", spots, {maxAge:60*60*24*7})
                                            popupRef.current._close()
                                        }}>登録する</button>
                                </li>
                                <li>
                                    <button className='c-btn c-btn-line c-btn-xs' type="button" 
                                        onClick={() => {
                                            spots.splice(index, 1)
                                            setCookie("spots", spots, {maxAge:60*60*24*7})
                                        }}>削除する</button>
                                </li>
                            </ul>
                        }
                    </Popup>
                }
                { process.env.REACT_APP_KASHIKA == 2 &&
                    <Popup autoPan={false} minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
                    <Line
                        height={300}
                        width={300}
                        data={state.currentPopup}
                        options={{
                            maintainAspectRatio: false,
                        }}
                        id="chart-key"
                    />
                    </Popup>
                }
            </Marker>       
        );
    }else{
        return null
    }
}

export default Component;
